module.exports = __webpack_public_path__ + "img/title-3.863879b4.png";